import { Auth } from '@grammarly/identity-ui'

import { gnarSpec } from '../../lib/tracking/gnar'

export class GoogleOneTapTracker implements Auth.Tracking.GoogleOneTap.Tracker {
  constructor(
    private pageId: string,
    private pageSlug: string
  ) {}

  trackOneTapPopupChange = (change: Auth.Tracking.GoogleOneTap.PopupChangeEvent, reason?: string) => {
    void gnarSpec.googleOneTapPopupChange(change, this.pageId, this.pageSlug, reason)
  }

  trackGoogleAuthSuccess = () => {
    void gnarSpec.googleOneTapAuthSuccess(this.pageId, this.pageSlug)
  }

  trackGoogleAuthFail = () => {
    void gnarSpec.googleOneTapAuthFail(this.pageId, this.pageSlug)
  }
}
